import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextBlock from "../../components/general/staticPages/aboutUs/textBlock";
import {Typography} from "@mui/material";
import Images from "../../assets";
import React from "react";

function ServiceBanner({ image, title }) {
    return (
        <Box
            sx={{
                position: "relative",
                width: "100%",
                borderRadius: 4,          // ~32px
                overflow: "hidden",
                height: { xs: 220, sm: 280, md: 420 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "linear-gradient(180deg, rgba(0,0,0,0.5) 18.75%, rgba(0,0,0,0.1) 100%)",
                }}
            />
            <Typography
                component="h2"
                sx={{
                    position: "relative",
                    zIndex: 1,
                    fontFamily: "'Zen Maru Gothic', system-ui, sans-serif",
                    fontWeight: 900,
                    textTransform: "uppercase",
                    color: "#F0F0F0",
                    lineHeight: 1.05,
                    px: { xs: 2, md: 6 },
                    maxWidth: 900,
                    fontSize: { xs: 22, sm: 28, md: 40, lg: 48 },
                    textShadow: "0 6px 24px rgba(0,0,0,0.35)",
                }}
            >
                {title}
            </Typography>
        </Box>
    );
}





const ExtraPage = ()=>{

    const bodyRight = `
  <p>
    A vitae consequat pulvinar ligula. Amet in viverra fringilla morbi suspendisse posuere platea lorem non.
    Aliquam elementum ac suspendisse neque imperdiet lacus quisque. Mi senectus nam id vitae non iaculis faucibus.
    Amet sed aliquam quis fermentum.
  </p>

  <p>
    Sodales feugiat tortor sed ipsum sapien arcu. Arcu amet libero vestibulum sed imperdiet.
    Lobortis nulla pulvinar donec nunc integer amet suspendisse. Ipsum tellus et erat orci odio.
    Convallis mi tincidunt faucibus in eu enim. Lectus nisl mollis non tortor id nec.
    Dui amet penatibus pulvinar nisl nunc. Nulla urna porttitor et in pretium iaculis quam orci.
    Ipsum et tincidunt sapien ullamcorper et. Etiam sodales nibh augue velit.
  </p>

 <ul>
    <li>
      A vitae consequat pulvinar ligula. Amet in viverra fringilla morbi suspendisse posuere platea lorem non.
      Aliquam elementum ac suspendisse neque imperdiet lacus quisque. Mi senectus nam id vitae non iaculis faucibus.
      Amet sed aliquam quis fermentum.
    </li>

    <li>
      Sodales feugiat tortor sed ipsum sapien arcu. Arcu amet libero vestibulum sed imperdiet.
      Lobortis nulla pulvinar donec nunc integer amet suspendisse. Ipsum tellus et erat orci odio.
      Convallis mi tincidunt faucibus in eu enim. Lectus nisl mollis non tortor id nec.
      Dui amet penatibus pulvinar nisl nunc.
    </li>
  </ul>
`;


    return (
        <Box sx={{ py: 1, display: "flex", flexDirection: "column", gap: 4,px:2,
            //backgroundColor:"#E9E9E9"
        }}>
            <Grid container spacing={3} sx={{ display: "flex", flexDirection: "column", alignContent:'center' }}>
                <Grid item xs={12} md={11}>
                    <ServiceBanner
                        image={Images.headerCoffee}
                        title="THis is a big title for brew specialists Extra content"
                    />
                </Grid>
                <Grid item xs={12} md={11}>
                    <TextBlock
                        title={"Egestas neque venenatis morbi diam ipsum elit proin vivamus"}
                        body={bodyRight}
                        variant="panel"
                        src={Images.articleImage}
                        alt="article"
                    />
                </Grid>
            </Grid>
        </Box>
    );

}
export default ExtraPage